(() => {
  const root = document.documentElement;
  let observer;
  function init() {
    observer?.disconnect();
    const bar = document.querySelector('.top-header');
    const header = document.querySelector('.header-wrap');
    const measure = () => {
      const height = bar?.getBoundingClientRect().height || 0;
      root.style.setProperty('--nat-announcement-height', `${height}px`);
      root.style.setProperty('--nat-header-stack', `${height + (header?.getBoundingClientRect().height || 0)}px`);
    };
    measure();
    observer = new ResizeObserver(measure);
    if (bar) observer.observe(bar);
    if (header) observer.observe(header);
    const normalize = path => path.replace(/\/+$/, '') || '/';
    const current = normalize(location.pathname);
    document.querySelectorAll('#main-nav .lvl1 > a, #mobile_nav .lvl1 > a').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#')) return;
      const url = new URL(raw, location.href);
      const selected = url.origin === location.origin && normalize(url.pathname) === current && !url.hash;
      if (selected) link.setAttribute('aria-current', 'page');
      else if (link.getAttribute('aria-current') === 'page') link.removeAttribute('aria-current');
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
})();
